module.exports = __webpack_public_path__ + "static/media/benefits1.9439b30e.jpg";